import React from 'react';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Link } from '@sravni/react-design-system/lib/Typography';
import { useStyles } from '@sravni/react-utils';
import { defaultMenuLinks } from '../../Footer/constants/menuLinks.js';
import { ThemeSwitcher } from '../../ThemeSwitcher/ui/ThemeSwitcher.js';
import modules_3e23959b from '../styles/FooterLinks.module.less.js';

const makeNav = (item) => item.children?.map((elem) => (React.createElement(Link, { href: elem.href, color: "gray", ...(elem.nofollow ? { rel: 'nofollow' } : {}), key: elem.href }, elem.noindex ? React.createElement("noindex", null, elem.text) : elem.text)));
const FooterLinks = ({ className, menuLinks = defaultMenuLinks, ...rest }) => {
    const cx = useStyles(modules_3e23959b);
    return (React.createElement(Space, { size: [12, 12], className: cx(className, 'container'), wrap: true, ...rest },
        menuLinks.map(makeNav),
        React.createElement(ThemeSwitcher, null)));
};
FooterLinks.displayName = 'FooterLinks';

export { FooterLinks };
//# sourceMappingURL=FooterLinks.js.map
